/*
  Abas de "Últimos lançamentos" (sections/enner-lancamentos.liquid).

  <enner-abas>
    <div role="tablist"> <button role="tab" aria-controls="painel-x" aria-selected="true"> ... </div>
    <div role="tabpanel" id="painel-x"> ... </div>  (os outros painéis com [hidden])
  </enner-abas>

  Clique ou setas do teclado trocam a aba; no editor de temas, escolher um bloco "Aba" ou um
  bloco "Produto do mini card" abre a aba certa. O carrossel do mini card (enner-carrossel,
  assets/enner-home.js) é avisado ao abrir uma aba para recalcular as setas, porque dentro de
  um painel escondido ele não consegue medir o trilho.
*/
(() => {
  if (customElements.get('enner-abas')) return;

  class EnnerAbas extends HTMLElement {
    connectedCallback() {
      this.abas = Array.from(this.querySelectorAll('[role="tab"]'));
      this.paineis = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.abas.length) return;

      this.aoClicar = (evento) => {
        const aba = evento.target.closest('[role="tab"]');
        if (!aba || !this.abas.includes(aba)) return;
        this.ativar(this.abas.indexOf(aba), true);
      };

      this.aoTeclar = (evento) => {
        const aba = evento.target.closest('[role="tab"]');
        if (!aba || !this.abas.includes(aba)) return;
        const atual = this.abas.indexOf(aba);
        let alvo = null;
        if (evento.key === 'ArrowRight') alvo = (atual + 1) % this.abas.length;
        if (evento.key === 'ArrowLeft') alvo = (atual - 1 + this.abas.length) % this.abas.length;
        if (evento.key === 'Home') alvo = 0;
        if (evento.key === 'End') alvo = this.abas.length - 1;
        if (alvo === null) return;
        evento.preventDefault();
        this.ativar(alvo, true);
      };

      this.aoEscolherBloco = (evento) => {
        if (!this.contains(evento.target)) return;
        const aba = evento.target.closest('[role="tab"]');
        const painel = evento.target.closest('[role="tabpanel"]');
        let indice = -1;
        if (aba) indice = this.abas.indexOf(aba);
        else if (painel) indice = this.paineis.indexOf(painel);
        if (indice < 0) return;
        this.ativar(indice, false);
        const item = evento.target.closest('[data-trilho] > *');
        const carrossel = item && item.closest('enner-carrossel');
        if (item && carrossel && typeof carrossel.rolarPara === 'function') carrossel.rolarPara(item);
      };

      // Degradê de "tem mais abas": o CSS desenha, aqui só se marca quando a rolagem está no fim
      // (ou quando não há o que rolar).
      this.tablist = this.querySelector('[role="tablist"]');
      this.aoRolarAbas = () => {
        const t = this.tablist;
        if (!t) return;
        const fim = t.scrollWidth - t.clientWidth <= 2 || t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
        t.toggleAttribute('data-fim', fim);
      };
      if (this.tablist) {
        this.tablist.addEventListener('scroll', this.aoRolarAbas, { passive: true });
        window.addEventListener('resize', this.aoRolarAbas);
        this.aoRolarAbas();
      }

      this.addEventListener('click', this.aoClicar);
      this.addEventListener('keydown', this.aoTeclar);
      document.addEventListener('shopify:block:select', this.aoEscolherBloco);

      const inicial = this.abas.findIndex((aba) => aba.getAttribute('aria-selected') === 'true');
      this.ativar(inicial >= 0 ? inicial : 0, false);
    }

    disconnectedCallback() {
      if (this.tablist) this.tablist.removeEventListener('scroll', this.aoRolarAbas);
      window.removeEventListener('resize', this.aoRolarAbas);
      this.removeEventListener('click', this.aoClicar);
      this.removeEventListener('keydown', this.aoTeclar);
      document.removeEventListener('shopify:block:select', this.aoEscolherBloco);
    }

    ativar(indice, focar) {
      this.abas.forEach((aba, i) => {
        const ativa = i === indice;
        aba.setAttribute('aria-selected', ativa ? 'true' : 'false');
        aba.tabIndex = ativa ? 0 : -1;
        if (ativa && focar) aba.focus();
        if (ativa && typeof aba.scrollIntoView === 'function') {
          aba.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
      this.paineis.forEach((painel, i) => {
        painel.hidden = i !== indice;
      });
      if (this.aoRolarAbas) this.aoRolarAbas();
      const painel = this.paineis[indice];
      if (!painel) return;
      painel.querySelectorAll('enner-carrossel').forEach((carrossel) => {
        if (typeof carrossel.atualizar === 'function') carrossel.atualizar();
      });
    }
  }

  customElements.define('enner-abas', EnnerAbas);
})();
